// extracted by mini-css-extract-plugin
export default {"link":"rR-z","disabled":"sR-z"};